// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__eJwei","buttonSmall":"button_buttonSmall__s2Bzu"};